export default __webpack_public_path__ + "static/media/mojaco_sorry.0e8d1523.png";